import { Flex, Loading, Text } from '@/components';
import { TableFundOwnerForLocalGovernment } from '@/features/mold/components';
import { PAPER_FILE_SIZE } from '@/features/mold/utils';
import { useProject } from '@/features/project/_hooks/project';
import { useLocalGovernmentFundIndividualReport } from '@/features/project/_hooks/report-individual';
import { useId } from '@/hooks';
import { useTranslation } from 'react-i18next';

export const FundOwnerForLocalGovernmentReportPage = () => {
  const { t } = useTranslation();
  const { id: projectId } = useId();
  const project = useProject(projectId);
  const localGovernmentFundIndividualReport =
    useLocalGovernmentFundIndividualReport(projectId);
  const isLoading = project.isLoading;

  return isLoading ? (
    <Loading />
  ) : (
    <Flex
      vertical
      style={{
        width: PAPER_FILE_SIZE.A4.height,
        printColorAdjust: 'exact',
        WebkitPrintColorAdjust: 'exact',
      }}
    >
      <Flex vertical>
        <Text
          weight="regular"
          variant="footnote"
          text={t(
            'report-fund-owner-for-local-government-individual-table-title',
            {
              year: project.data?.fiscalYear,
              projectName: project.data?.name,
            },
          )}
        />
        <Flex justify="flex-end">
          <Text
            weight="regular"
            variant="small"
            text={t('report-amount-unit-description')}
          />
        </Flex>
      </Flex>

      <TableFundOwnerForLocalGovernment
        fiscalYear={project.data?.fiscalYear}
        localGovernmentFundIndividualReport={
          localGovernmentFundIndividualReport.data
        }
      />
    </Flex>
  );
};
